const DepositoryServices = `
<div class="card m-5">
<div class="card-body">
  <div class="row iconpadding">
    <div class="col-12 mt-2 mb-2 text-center">
      <h2 class="greencolor">
        <span style="color:#4A9530; font-weight:900; font-size:40px;">Depository Services</span>
      </h2>
    </div>

    <div class="col-12">
      <p>Main function of Depository Services is the holding securities either in certificated or uncertificated (dematerialized) form. In the depository system, securities are held in depository accounts, which are similar to holding funds in bank accounts. Transfer of ownership of securities is done through simple account transfers.</p>

      <p><b style="color: rgb(74, 149, 48);">Types of Depository Services:</b></p>

      <p style="font-weight:bold">1. NSDL (National Securities Depository Limited)</p>

      <p style="font-weight:bold">2. CDSL (Central Depository Services Limited)</p>

      <p><span style="color:#4A9530;font-weight:bold">NSDL (National Securities Depository Limited): </span> This is the first central securities depository in India based in Mumbai. It is promoted by institutions of national stature responsible for the economic development of India.</p>

      <p>NSDL is promoted by NSE (National Stock Exchange), IDBI (Industrial Development Bank of India Limited), UTI (Unit Trust of India), and some of prominent banks in the country have taken a stake in NSDL.</p>

      <p>SBI, HDFC Bank, Axis Bank, OBC, Dena Bank, Canara Bank, Union Bank of India etc.</p>

      <p><span style="color:#4A9530;font-weight:bold">CDSL (Central Depository Services Limited): </span> This is the second Indian central securities depository based in Mumbai.</p>

      <p>CDSL is promoted by Bombay Stock Exchange (BSE), State Bank of India (SBI), Bank of India, Bank of Baroda, HDFC Bank, Standard Chartered Bank, and Union Bank of India.</p>
    </div>
  </div>
</div>
</div>
`;
const visionAndMission = `
<div class="card m-5">
    <div class="card-body">
        <div class="row iconpadding">
            <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12" style="margin-top:4%;margin-bottom:3%">
                <h2 class="greencolor text-center">
                    <span style="color:gray; font-weight:900;font-size:40px;">Powerful Strategist</span>
                </h2>
                <div class="row">
                    <div class="col-lg-2 col-sm-12 col-md-2 col-xs-12">
                        <img src="https://marfatia.net/IMAGES/vision.png">
                    </div>
                    <div class="col-lg-9 col-sm-12 col-md-9 col-xs-12" style="margin-top:3%">
                        <h3 style="color:#424242">
                            Put your <span style="color:#4A9530"> Future</span> in the hands of people you can <span style="color:#4A9530"> Trust !</span>
                        </h3>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>

`;

const dispositoryervice = `

<div class="card m-5">
    <div class="card-body">
<div class="row iconpadding">
<div class="col-lg-12 col-sm-12 col-md-12 col-xs-12" style="margin-top:2%;margin-bottom:2%">
<h2 class="greencolor text-center "><span style="color:#4A9530; font-weight:900;font-size:40px;">Depository Services </span></h2>

<div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
<p>Main function of Depository Services is the holding securities either in certificated or uncertificated (dematerialized) form. In the depository system, securities are held in depository accounts, which are similar to holding funds in bank accounts. Transfer of ownership of securities is done through simple account transfers.</p>

<p><b style="color: rgb(74, 149, 48);">Types of Depository Services:</b></p>

<p style="font-weight:bold">1. NSDL (National Securities Depository Limited)</p>

<p style="font-weight:bold">2. CDSL (Central Depository Services Limited)</p>

<p><span style="color:#4A9530;font-weight:bold">NSDL (National Securities Depository Limited): </span> This is the first central securities depository in India based in Mumbai. It is promoted by institutions of national stature responsible for the economic development of India.</p>

<p>NSDL is promoted by NSE (National Stock Exchange), IDBI (Industrial Development Bank of India Limited), UTI (Unit Trust of India), and some of prominent banks in the country have taken a stake in NSDL.</p>

<p>SBI, HDFC Bank, Axis Bank, OBC, Dena Bank, Canara Bank, Union Bank of India etc.</p>

<p><span style="color:#4A9530;font-weight:bold">CDSL (Central Depository Services Limited): </span> This is the second Indian central securities depository based in Mumbai.</p>

<p>CDSL is promoted by Bombay Stock Exchange (BSE), State Bank of India (SBI), Bank of India, Bank of Baroda, HDFC Bank, Standard Chartered Bank, and Union Bank of India.</p>
</div>
</div>

<div class="col-lg-12 col-sm-12 col-md-12 col-xs-12" style="margin-bottom:2%">
<div class="col-lg-2 col-sm-12 col-md-2 col-xs-12">&nbsp;</div>

<div class="col-lg-8 col-sm-12 col-md-8 col-xs-12" style="margin-left: 95px;">
<div class="col-lg-4 col-sm-12 col-md-4 col-xs-12">

</div>
</div>
</div>
</div>
`;

const stockBrker = `<section style="padding: 30px 0;">
<div class="container">
    <div class="row">
        <div class="col-md-12">

            <div class="content-bg content-base-wrap">
            <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="text-center" style="color:#85c226"><strong>VISION</strong></h4>
                    <p class="text-center">To follow the highest standards of ethics and compliance while facilitating trading by clients in securities in a fair and transparent manner, contributing to the creation of wealth for investors.</p>
                </div>
            </div>
            <br/>
            <div class="row">
    <div class="col-md-12">
        <h4 class="text-center" style="color:#85c226"><strong>MISSION</strong></h4>

        <ul class="list-group">
            <li class="list-group-item"> To provide high-quality and dependable service through innovation, capacity enhancement, and the use of technology.</li>
            <li class="list-group-item"> To establish and maintain a relationship of trust and ethics with investors.</li>
            <li class="list-group-item"> To observe the highest standards of compliance and transparency.</li>
            <li class="list-group-item"> To always keep 'protection of investors' interest' as the goal while providing service.</li>
        </ul>
    </div>
</div>
<br/>
<br/>
<div class="row">
<div class="col-md-12">
<h4 class="text-center" style="color:#85c226"><strong>Services provided to Investors</strong></h4>
<ul class="list-group">
    <li class="list-group-item">Execution of trades on behalf of investors.</li>
    <li class="list-group-item">Issuance of Contract Notes.</li>
    <li class="list-group-item">Issuance of intimations regarding margin due payments.</li>
    <li class="list-group-item">Facilitate execution of early pay-in obligation instructions.</li>
    <li class="list-group-item">Settlement of client's funds.</li>
    <!-- Add more list items as needed -->
</ul>
</div>

</div>


<br/>


            <div class="row">
            <div class="col-md-12">
            <h4 class="text-center" style="color:#85c226"><strong>Rights of Investors</strong></h4>
            <ul class="list-group">
                <li class="list-group-item">
                    <strong>Ask</strong> for and receive information from a firm about the work history and background of the person handling your account, as well as information about the firm itself.
                </li>
                <li class="list-group-item">
                    <strong>Receive</strong> complete information about the risks, obligations, and costs of any investment before investing.
                </li>
                <li class="list-group-item">
                    <strong>Receive</strong> recommendations consistent with your financial needs and investment objectives.
                </li>
                <li class="list-group-item">
                    <strong>Receive</strong> a copy of all completed account forms and agreements.
                </li>
                <!-- Add more list items as needed -->
            </ul>
        </div>
        
            </div>
        </div>
        <br>
        <br>
        <div class="container mt-4">
        <h4 class="text-center" style="color:#85c226">Various activities of Stock Brokers with timelines</h4>
        <table class="table table-bordered table-striped">
            <thead class="thead-dark">
                <tr>
                    <th>S.No</th>
                    <th>Activities</th>
                    <th>Expected Timelines</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>KYC entered into KRA System and CKYCR</td>
                    <td>10 days of account opening</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Client Onboarding</td>
                    <td>Immediate, but not later than one week</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>Order execution</td>
                    <td>Immediate on receipt of order, but not later than the same day</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>Allocation of Unique Client Code</td>
                    <td>Before trading</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>Copy of duly completed Client Registration Documents to clients</td>
                    <td>7 days from the date of upload of Unique Client Code to the Exchange by the trading member</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>Issuance of contract notes</td>
                    <td>24 hours of execution of trades</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>Collection of upfront margin from client</td>
                    <td>Before initiation of trade</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>Issuance of intimations regarding other margin due payments</td>
                    <td>At the end of the T day</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>Settlement of client funds</td>
                    <td>30 days / 90 days for running account settlement (RAS) as per the preference of client. If consent not given for RAS – within 24 hours of pay-out</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>'Statement of Accounts' for Funds, Securities and Commodities</td>
                    <td>Weekly basis (Within four trading days of following week)</td>
                </tr>
                <tr>
                    <td>11</td>
                    <td>Issuance of retention statement of funds/commodities</td>
                    <td>5 days from the date of settlement</td>
                </tr>
                <tr>
                    <td>12</td>
                    <td>Issuance of Annual Global Statement</td>
                    <td>30 days from the end of the financial year</td>
                </tr>
                <tr>
                    <td>13</td>
                    <td>Investor grievances redressal</td>
                    <td>30 days from the receipt of the complaint</td>
                </tr>
            </tbody>
        </table>
    </div>
    <br>
    <br>
                
                <div class="container mt-4">
    <table class="table table-bordered table-striped">
        <thead class="thead-dark">
            <tr>
            <h4 class="text-center" style="color:#85c226"><Strong>DOs and DON’Ts for Investors</Strong></h4>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td><strong>DOs</strong></td>
                <td><strong>DON'Ts</strong></td>
            </tr>
            <tr>
                <td>1. Read all documents and conditions being agreed before signing the account opening form.</td>
                <td>1. Do not deal with unregistered stock brokers.</td>
            </tr>
            <tr>
                <td>2. Receive a copy of KYC, copy of account opening documents, and Unique Client Code.</td>
                <td>2. Do not forget to strike off blanks in your account opening and KYC.</td>
            </tr>
            <tr>
                <td>3. Read the product / operational framework / timelines related to various Trading and Clearing &amp; Settlement processes.</td>
                <td>3. Do not submit an incomplete account opening and KYC form.</td>
            </tr>
            <tr>
                <td>4. Receive all information about brokerage, fees, and other charges levied.</td>
                <td>4. Do not forget to inform any change in information linked to a trading account and obtain confirmation of updation in the system.</td>
            </tr>
            <tr>
                <td>5. Register your mobile number and email ID in your trading, demat, and bank accounts to get regular alerts on your transactions.</td>
                <td>5. Do not transfer funds, for the purposes of trading, to anyone other than a stock broker. No payment should be made in the name of an employee of a stock broker.</td>
            </tr>
            <tr>
                <td>6. If executed, receive a copy of Power of Attorney. However, Power of Attorney is not a mandatory requirement as per SEBI / Stock Exchanges. Before granting Power of Attorney, carefully examine the scope and implications of powers being granted.</td>
                <td>6. Do not ignore any emails / SMSs received with regards to trades done, from the Stock Exchange and raise a concern, if a discrepancy is observed.</td>
            </tr>
            <tr>
                <td>7. Receive contract notes for trades executed, showing transaction price, brokerage, GST, and STT, etc. as applicable, separately, within 24 hours of execution of trades.</td>
                <td>7. Do not opt for digital contracts if not familiar with computers.</td>
            </tr>
            <tr>
                <td>8. Receive funds and securities / commodities on time within 24 hours from pay-out.</td>
                <td>8. Do not share trading password.</td>
            </tr>
            <tr>
                <td>9. Verify details of trades, contract notes, and statement of account and approach relevant authority for any discrepancies. Verify trade details on the Exchange websites from the trade verification facility provided by the Exchanges.</td>
                <td>9. Do not fall prey to fixed / guaranteed returns schemes.</td>
            </tr>
            <tr>
                <td>10. Receive a statement of accounts periodically. If opted for running account settlement, the account has to be settled by the stockbroker as per the option given by the client (30 or 90 days).</td>
                <td>10. Do not fall prey to fraudsters sending emails and SMSs luring to trade in stocks / securities promising huge profits.</td>
            </tr>
            <tr>
                <td>11. In case of any grievances, approach stockbroker or Stock Exchange or SEBI for getting the same resolved within prescribed timelines.</td>
                <td>11. Do not follow herd mentality for investments. Seek expert and professional advice for your investments.</td>
            </tr>
        </tbody>
    </table>
</div>
<br>
<div style="margin-top: 20px;">
<h4 class="info-title">Grievance Redressal Mechanism</h4>
<hr style="border-top: 2px solid #ccc; margin-top: 10px;">

<strong>Level 1 – Approach the Stock Broker:</strong>
<p>Reach out to the Stock Broker at their designated Investor Grievance e-mail ID. The Stock Broker will make every effort to address the grievance immediately, aiming to resolve it within 30 days of receiving the complaint.</p>

<strong>Level 2 – Approach the Stock Exchange:</strong>
<p>If the issue remains unresolved, you can escalate it to the Stock Exchange. Details on how to submit a complaint can be found on the respective exchange's website.</p>
<br>
<div style="text-align: center;">
    <img src="https://nodeapp.barodaweb.com/api/files/img1.jpg" alt="Complaints Resolution Process at Stock Exchange" style="max-width: 100%;">
</div>
</div>

                &nbsp;
            <h4 class="text-center" style="color:#85c226"><Strong>Timelines for complaint resolution process at Stock Exchanges against stock brokers</Strong></h4>

            <div style="margin-top: 20px;">
            <table class="table table-bordered" style="width: 100%;">
                <thead>
                    <tr>
                        <th style="width: 10%;">S.No</th>
                        <th style="width: 50%;">Type of Activity</th>
                        <th style="width: 40%;">Timelines for Activity</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Receipt of Complaint</td>
                        <td>Day of complaint (C Day)</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Additional information sought from the investor, if any, and provisionally forwarded to stock broker.</td>
                        <td>C + 7 Working days</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Registration of the complaint and forwarding to the stock broker.</td>
                        <td>C + 8 Working Days i.e. T day</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Amicable Resolution.</td>
                        <td>T + 15 Working Days</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Refer to Grievance Redressal Committee (GRC), in case of no amicable resolution.</td>
                        <td>T + 16 Working Days</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Complete resolution process post GRC.</td>
                        <td>T + 30 Working Days</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>In case where the GRC Member requires additional information, GRC order shall be completed within.</td>
                        <td>T + 45 Working Days</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>Implementation of GRC Order.</td>
                        <td>On receipt of GRC Order, if the order is in favor of the investor, debit the funds of the stock broker. Order for debit is issued immediately or as per the directions given in GRC order.</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>In case the stock broker is aggrieved by the GRC order, will provide intention to avail arbitration</td>
                        <td>Within 7 days from receipt of order</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>If intention from stock broker is received and the GRC order amount is up to Rs.20 lakhs</td>
                        <td>Investor is eligible for interim relief from Investor Protection Fund (IPF). The interim relief will be 50% of the GRC order amount or Rs.2 lakhs whichever is less. The same shall be provided after obtaining an Undertaking from the investor.</td>
                    </tr>
                    <tr>
                        <td>11</td>
                        <td>Stock Broker shall file for arbitration</td>
                        <td>Within 6 months from the date of GRC recommendation</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>In case the stock broker does not file for arbitration within 6 months</td>
                        <td>The GRC order amount shall be released to the investor after adjusting the amount released as interim relief, if any.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div class="info-block">
        <h5 class="text-center" style="color:#85c226"><Strong>Handling of Investor’s claims / complaints in case of default of a Trading Member / Clearing Member (TM/CM)</Strong></h5>

       
    
        <p> <strong>Following steps are carried out by Stock Exchange for the benefit of investors in case a stock broker defaults:</strong></p>
        <ul>
            <li> - Circular is issued to inform about the declaration of the Stock Broker as a Defaulter.</li>
            <li> - Information of the defaulter stock broker is disseminated on the Stock Exchange website.</li>
            <li> - Public Notice is issued informing the declaration of a stock broker as a defaulter and inviting claims within a specified period.</li>
            <li> - Intimation to clients of defaulter stock brokers via emails and SMS for facilitating lodging of claims within the specified period.</li>
        </ul>
    
        <p> <strong>Following information is available on the Stock Exchange website for the information of investors:</strong></p>
        <ul>
            <li> -  Norms for eligibility of claims for compensation from IPF.</li>
            <li> -  Claim form for lodging claims against defaulter stock broker.</li>
            <li> -  FAQ on processing of investors’ claims against Defaulter stock broker.</li>
            <li> -  Provision to check online status of the client’s claim.</li>
        </ul>
    </div>
    <strong> Level 3</strong>
<p>The complaint not redressed at Stock Broker / Stock Exchange level, may be lodged with SEBI on SCORES (a web based centralized grievance redressal system of SEBI) @<a href="https://scores.gov.in/scores/Welcome.html" target="_blank">https://scores.gov.in/scores/Welcome.html</a>
</p>

    <br>
    <br>

                <h4 class="text-center" style="color:#85c226">Investor Complaints Data for Marfatia Broking Pvt Ltd.(Stock Brokers)</h4>
                <h4 class="text-center" style="color:#85c226">Data for Every Month Ending – August, 2023</u></h4>
                
<div class="table-responsive">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th scope="col">S.No</th>
                <th scope="col">Received from</th>
                <th scope="col">Carried forward from previous month</th>
                <th scope="col">Received during the month</th>
                <th scope="col">Total Pending</th>
                <th scope="col">Resolved*</th>
                <th colspan="2" scope="col">Pending at the end of the month**</th>
                <th scope="col">Average Resolution time^ (in days)</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td>Directly from Investors</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>2</td>
                <td>SEBI (SCORES)</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>3</td>
                <td>Stock Exchanges</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>4</td>
                <td>Other Sources (if any)</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>5</td>
                <td>Grand Total</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
        </tbody>
    </table>
</div>
<br>
<h4 class="text-center" style="color:#85c226">Trend of Monthly Disposal of Complaints</h4>
<p>
    <strong>*</strong> This includes complaints from previous months that were resolved in the current month, if any.
    <br>
    <strong>**</strong> This includes the total number of complaints pending as of the last day of the month, if any.
    <br>
    <strong>^</strong> Average resolution time is calculated as the total time taken to resolve each complaint in the current month, divided by the total number of complaints resolved in the current month.
</p>

<div class="table-responsive">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th scope="col">S.No</th>
                <th scope="col">Month</th>
                <th scope="col">Carried forward from previous month</th>
                <th scope="col">Received</th>
                <th scope="col">Resolved*</th>
                <th scope="col">Pending**</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td>Sep-2022</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>2</td>
                <td>Oct-2022</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>3</td>
                <td>Nov-2022</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>4</td>
                <td>Dec-2022</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>5</td>
                <td>Jan-2023</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>6</td>
                <td>Feb-2023</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>7</td>
                <td>Mar-2023</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>8</td>
                <td>Apr-2023</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <tr>
                <td>9</td>
                <td>May-2023</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
            </tr>
            <!-- Continue adding rows as needed -->
        </tbody>
    </table>
</div>
  



                
<br>
                <h4 class="text-center" style="color:#85c226"><strong>Trend of Annual disposal of complaints</strong></h4>


                <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Year</th>
                            <th scope="col">Carried forward from previous year</th>
                            <th scope="col">Received during the year</th>
                            <th scope="col">Resolved during the year</th>
                            <th scope="col">Pending at the end of the year</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>2017-18</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>2018-19</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>2019-20</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>2020-21</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>2021-22</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td><strong>Grand Total</strong></td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            

            </div>

        </div>
    </div>
</div>
</section>`;

export const content = stockBrker;
